import { Component, OnInit, OnDestroy } from '@angular/core';
import { Class } from '../../class';
import { ClassService } from '../../class.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { MatSnackBar } from '@angular/material';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';
import { SignlaterService } from '../../signlater.service';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.scss']
})
export class StudentsComponent implements OnInit, OnDestroy {
  private error$: Subscription;
  private classes: Observable<Class[]>;

  constructor(
    private classService: ClassService,
    private snackbar: SemsoSnackbarService,
    private signLaterService: SignlaterService) { }

  ngOnInit() {
    this.subscribe();
    this.signLaterService.reload();
  }

  ngOnDestroy(): void {
    this.error$.unsubscribe();
  }

  private subscribe() {
    this.error$ = this.classService.loadingError$.subscribe(data => {
      this.snackbar.error('Klassen kunnen niet worden opgehaald');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/students/students/students.component.ts